import { z } from 'zod';

export const sendMessageSchema = z.object({
  text: z.string().min(1, 'Mensagem vazia').max(5000),
  attachmentS3Keys: z.array(z.string()).max(5).optional(),
});

export const messageListQuerySchema = z.object({
  before: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export type SendMessageInput = z.infer<typeof sendMessageSchema>;
export type MessageListQuery = z.infer<typeof messageListQuerySchema>;
